module.exports = __webpack_public_path__ + "videos/how-did-harry-houdini-escape.ccedbf2.mp4";